import { render, staticRenderFns } from "./PaymentMethodModal.vue?vue&type=template&id=2e48f3f8&scoped=true&"
import script from "./PaymentMethodModal.vue?vue&type=script&lang=ts&"
export * from "./PaymentMethodModal.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentMethodModal.vue?vue&type=style&index=0&id=2e48f3f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e48f3f8",
  null
  
)

export default component.exports